import React from 'react';

const EmptyDashboardIcon = () => (
  <svg width="534" height="472" viewBox="0 0 534 472" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="267" cy="225" r="74.25" stroke="#E5E7EB" strokeWidth="1.5" />
    <circle cx="267" cy="225" r="111.75" stroke="#E5E7EB" strokeWidth="1.5" />
    <circle cx="267" cy="225" r="149.25" stroke="#F3F4F6" strokeWidth="1.5" />
    <circle cx="267" cy="225" r="186.75" stroke="#F3F4F6" strokeWidth="1.5" />
    <circle cx="267" cy="225" r="224.25" stroke="#F9FAFB" strokeWidth="1.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M252.857 199.285C246.821 199.285 241.928 204.178 241.928 210.214V226.142C241.928 232.178 246.821 237.071 252.857 237.071H265.071V242.247L255.652 248.461C254.763 249.048 254.518 250.244 255.104 251.133C255.691 252.022 256.887 252.268 257.776 251.681L267 245.596L276.223 251.681C277.113 252.268 278.309 252.022 278.895 251.133C279.482 250.244 279.237 249.048 278.348 248.461L268.928 242.247V237.071H281.143C287.178 237.071 292.071 232.178 292.071 226.142V210.214C292.071 204.178 287.178 199.285 281.143 199.285H252.857ZM259.928 220.499C259.928 219.434 259.065 218.571 258 218.571C256.935 218.571 256.071 219.434 256.071 220.499V225.642C256.071 226.707 256.935 227.571 258 227.571C259.065 227.571 259.928 226.707 259.928 225.642V220.499ZM267 208.285C268.065 208.285 268.928 209.149 268.928 210.214V225.642C268.928 226.707 268.065 227.571 267 227.571C265.935 227.571 265.071 226.707 265.071 225.642V210.214C265.071 209.149 265.935 208.285 267 208.285ZM277.928 214.071C277.928 213.006 277.065 212.142 276 212.142C274.935 212.142 274.071 213.006 274.071 214.071V225.642C274.071 226.707 274.935 227.571 276 227.571C277.065 227.571 277.928 226.707 277.928 225.642V214.071Z"
      fill="#00A389"
    />
    <rect x="347.5" y="183.5" width="41" height="41" rx="13.5" fill="#F3F4F6" />
    <rect x="347.5" y="183.5" width="41" height="41" rx="13.5" stroke="#E5E7EB" />
    <path d="M359 194V214" stroke="#384250" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M359 213H368.5C369.328 213 370 212.328 370 211.5V210.5C370 209.672 369.328 209 368.5 209H359"
      stroke="#384250"
      strokeWidth="1.5"
    />
    <path
      d="M359 206H375.5C376.328 206 377 205.328 377 204.5V203.5C377 202.672 376.328 202 375.5 202H359"
      stroke="#384250"
      strokeWidth="1.5"
    />
    <path
      d="M359 199H366.5C367.328 199 368 198.328 368 197.5V196.5C368 195.672 367.328 195 366.5 195H359"
      stroke="#384250"
      strokeWidth="1.5"
    />
    <rect x="129.5" y="192.5" width="41" height="41" rx="13.5" fill="#F3F4F6" />
    <rect x="129.5" y="192.5" width="41" height="41" rx="13.5" stroke="#E5E7EB" />
    <path
      d="M157.559 213.928C157.559 218.622 153.753 222.428 149.059 222.428C144.364 222.428 140.559 218.622 140.559 213.928C140.559 209.233 144.364 205.428 149.059 205.428"
      stroke="#384250"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M159.195 209.456C158.374 206.749 156.238 204.613 153.53 203.792C153.002 203.632 152.481 203.999 152.383 204.542L151.313 210.513C151.19 211.198 151.788 211.796 152.474 211.674L158.444 210.603C158.988 210.506 159.355 209.984 159.195 209.456Z"
      stroke="#384250"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <rect x="239.5" y="92.5" width="33" height="33" rx="11.5" fill="#F3F4F6" />
    <rect x="239.5" y="92.5" width="33" height="33" rx="11.5" stroke="#E5E7EB" />
    <path
      d="M252.25 112L254.717 108.356C254.903 108.082 255.283 108.026 255.539 108.236L256.962 109.399C257.239 109.625 257.654 109.539 257.818 109.221L258.723 107.465C258.872 107.174 259.238 107.072 259.517 107.243L260.04 107.564C260.297 107.722 260.633 107.649 260.801 107.398L262.75 104.5"
      stroke="#384250"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M249.25 103.375V113.125C249.25 114.575 250.425 115.75 251.875 115.75H262.75"
      stroke="#384250"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="239.5" y="17.5" width="33" height="33" rx="11.5" fill="#F9FAFB" />
    <rect x="239.5" y="17.5" width="33" height="33" rx="11.5" stroke="#F3F4F6" />
    <path
      d="M249.25 41.5V38.5C249.25 37.8787 249.754 37.375 250.375 37.375H251.125C251.746 37.375 252.25 37.8787 252.25 38.5V41.5"
      stroke="#9DA4AE"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M259.75 41.5V34C259.75 33.3787 260.254 32.875 260.875 32.875H261.625C262.246 32.875 262.75 33.3787 262.75 34V41.5"
      stroke="#9DA4AE"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M254.5 41.4999V36.625C254.5 36.0037 255.004 35.5 255.625 35.5H256.375C256.996 35.5 257.5 36.0037 257.5 36.625V41.4999"
      stroke="#9DA4AE"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M249.399 34.4141C254.274 35.1641 259.787 31.7891 261.287 27.2891"
      stroke="#9DA4AE"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M258.713 27.4636L261.145 26.5489C261.592 26.3804 262.097 26.665 262.185 27.1352L262.661 29.6892"
      stroke="#9DA4AE"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="375.5" y="76.5" width="33" height="33" rx="11.5" fill="#F9FAFB" />
    <rect x="375.5" y="76.5" width="33" height="33" rx="11.5" stroke="#F3F4F6" />
    <path
      d="M385.25 88.875C385.25 87.4253 386.425 86.25 387.875 86.25H396.125C397.575 86.25 398.75 87.4253 398.75 88.875V97.125C398.75 98.5747 397.575 99.75 396.125 99.75H387.875C386.425 99.75 385.25 98.5747 385.25 97.125V88.875Z"
      stroke="#9DA4AE"
      strokeWidth="1.3"
    />
    <path
      d="M388.625 93C388.625 92.5858 388.961 92.25 389.375 92.25H389.938C390.352 92.25 390.688 92.5858 390.688 93V96H389.375C388.961 96 388.625 95.6642 388.625 95.25V93Z"
      stroke="#9DA4AE"
      strokeWidth="1.3"
    />
    <path
      d="M392.75 92.25C392.75 91.8358 393.086 91.5 393.5 91.5H394.062C394.477 91.5 394.812 91.8358 394.812 92.25V95.25C394.812 95.6642 394.477 96 394.062 96H392.75V92.25Z"
      stroke="#9DA4AE"
      strokeWidth="1.3"
    />
    <path
      d="M390.688 90.75C390.688 90.3358 391.023 90 391.438 90H392C392.414 90 392.75 90.3358 392.75 90.75V96H390.688V90.75Z"
      stroke="#9DA4AE"
      strokeWidth="1.3"
    />
    <rect x="89.5" y="99.5" width="33" height="33" rx="11.5" fill="#F9FAFB" />
    <rect x="89.5" y="99.5" width="33" height="33" rx="11.5" stroke="#F3F4F6" />
    <path
      d="M102.25 119L104.717 115.356C104.903 115.082 105.283 115.026 105.539 115.236L106.962 116.399C107.239 116.625 107.654 116.539 107.818 116.221L108.723 114.465C108.872 114.174 109.238 114.072 109.517 114.243L110.04 114.564C110.297 114.722 110.633 114.649 110.801 114.398L112.75 111.5"
      stroke="#9DA4AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.25 110.375V120.125C99.25 121.575 100.425 122.75 101.875 122.75H112.75"
      stroke="#9DA4AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect y="310" width="534" height="162" rx="37" fill="url(#paint0_linear_34833_85839)" fillOpacity="0.7" />
    <defs>
      <linearGradient
        id="paint0_linear_34833_85839"
        x1="243"
        y1="310"
        x2="243"
        y2="446.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default EmptyDashboardIcon;
